/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer } from '../runtime.js';

const es_persons_loading_members = /** @type {(inputs: {}) => string} */ () => {
	return `Cargando miembros...`
};

const en_persons_loading_members = /** @type {(inputs: {}) => string} */ () => {
	return `Loading members...`
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "es" | "en" }} options
* @returns {string}
*/
/* @__NO_SIDE_EFFECTS__ */
const persons_loading_members = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.persons_loading_members(inputs) 
	}
	const locale = options.locale ?? getLocale()
	trackMessageCall("persons_loading_members", locale)
	if (locale === "es") return es_persons_loading_members(inputs)
	return en_persons_loading_members(inputs)
};
export { persons_loading_members as "persons.loading_members" }